import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { DEFAULT_UI_LOCALE } from "@/i18n/locale";
import { zh_cn } from "@/i18n/resources/zh_cn";

void i18n.use(initReactI18next).init({
  lng: DEFAULT_UI_LOCALE,
  fallbackLng: DEFAULT_UI_LOCALE,
  supportedLngs: [DEFAULT_UI_LOCALE],
  resources: {
    [DEFAULT_UI_LOCALE]: zh_cn,
  },
  interpolation: {
    escapeValue: false,
  },
  returnNull: false,
});

export default i18n;
